import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "cell"]
  static values = { pgRowLabel: String, indexLabel: String }

  connect() {
    this.mode = localStorage.getItem("row-index-mode") || "page_row"
    this.apply()
  }

  toggle() {
    this.mode = this.mode === "page_row" ? "index" : "page_row"
    localStorage.setItem("row-index-mode", this.mode)
    this.apply()
  }

  apply() {
    this.headerTarget.textContent = this.mode === "page_row" ? this.pgRowLabelValue : this.indexLabelValue

    this.cellTargets.forEach(cell => {
      cell.textContent = this.mode === "page_row" ? cell.dataset.pageRow : cell.dataset.index
    })
  }
}
